import * as bi from 'react-bootstrap-icons';
import { Flex } from 'components';
import { dateFormat } from 'common/helpers';
import './style.scss';

interface IProps {
  cityName?: string | null;
  countryName?: string | null;
  regionName?: string | null;
  address?: string | null;
  departureDate?: string | Date | null;
  arrivalDate?: string | Date | null;
}

function PointCard(props: IProps) {
  const departureDate = dateFormat(props.departureDate, 'DD.MM.YYYY HH:mm');
  const arrivalDate = dateFormat(props.arrivalDate, 'DD.MM.YYYY HH:mm');

  return (
    <Flex
      gap={5}
      className='point-card-OpkcL'
    >
      <div className='i-cntr-ZbwGc city-i-cntr-DayE'>
        <bi.Buildings />
      </div>
      <Flex direction='column'>
        {
          <Flex direction='column'>
            <Flex alignItems='flex-end'>
              <span className='point-city-title-hMUq'>
                <b>{props.cityName ?? '—'}</b>
              </span>
              {props.countryName != null && <span className='point-country-Rqh2'>, {props.countryName}</span>}
            </Flex>

            {props.regionName != null && <span className='point-description-sc0m'>{props.regionName}</span>}
            {props.address != null && <span className='point-address-oAZI'>{props.address}</span>}
          </Flex>
        }

        {props.arrivalDate != null && (
          <Flex direction='column'>
            <span className='d-a-title-h91p'>Прибытие:</span>
            <span className='d-a-time-RbnJf'>
              {arrivalDate.datetime} ({arrivalDate.mskTimezone})
            </span>
          </Flex>
        )}

        {props.departureDate != null && (
          <Flex direction='column'>
            <span className='d-a-title-h91p'>Отправление:</span>
            <span className='d-a-time-RbnJf'>
              {departureDate.datetime} ({departureDate.mskTimezone})
            </span>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}

export default PointCard;
